import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";
import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'
import { TrajanjePromocije } from '../../Components/Layout/TrajanjePromocije.jsx'
import { BonusPobjednici } from '../../Components/Layout/BonusPobjednici.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import RiveComponent from "../../Components/Shared/RiveComponent";

export class BonusesHalloween extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Nagrade', 'Spooky igre', 'Rezultati'], selectedTab: null, igre: null, kampanja: null }


        this.setData = this.setData.bind(this);
        this.gotoTab = this.gotoTab.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.dohvatiBonusIgre = this.dohvatiBonusIgre.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Halloween', 'casino', this.props.user);
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab(this.state.tabs[0]);

        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn), casino.repos.casinoBonusRepo.get('NajveciBrojSpinovaHalloween2022')]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    setData(data) {
        var [igre, kategorije, kampanja] = data;
        this.setState({
            igre: igre,
            categories: kategorije.items,
            kampanja: kampanja
        });


        this.props.showLoadingFn(false);
    }

    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }


    renderIgra(igra) {
        return (
            <Game brands={this.props.brands} categories={this.state.categories} key={igra.sifra} igra={igra} showJackpot={false} routePrefix='/promotions/halloween' fromNative={casino.config.fromNativeApp} fromNativeGameName={true} />
        );
    }
    dohvatiBonusIgre() {
        let igre = [];
        this.state.kampanja.igreSifre.forEach((sifra) => {
            let igra = this.state.igre.find(it => it.sifra == sifra);
            if (igra) igre.push(igra);
        });

        return igre;
    }

    setPlace(nagrada, index) {
        if (nagrada.mjesto - this.state.kampanja.nagrade[index - 1].mjesto >= 2) {
            return `${this.state.kampanja.nagrade[index - 1].mjesto + 1}.-${nagrada.mjesto}. mjesto`;
        } else if (nagrada.mjesto - this.state.kampanja.nagrade[index - 1].mjesto == 1) {
            return `${nagrada.mjesto}. mjesto`;
        }
    }

    getUTCDate(d) {
        let date = new Date(d);
        return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }


    render() {
        return (
            <div >
                <MetaTags title="Bonusi - SuperSport CASINO" description="Game race bonusi u SuperSport CASINU!" />
                <Header key="header" {...this.state} {...this.props}></Header>

                <div className='white-background'>
                    <div className="banner banner2">
                        <section className="hallowen2 banner--inner selected">
                            <div className="banner--content">
                                <div className="banner--bg-container">
                                    <div className="banner--repeater" />
                                    <div className="banner--background" />
                                    {/* <div className="banner--mask-white" /> */}
                                </div>
                                <div className="banner--foreground">
                                    <div className="banner--image">
                                        <RiveComponent
                                            lazyLoad={true}
                                            cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                            src={`${casino.config.casinoCDNImagesUrl}/Banners/Halloween/halloween_2022.riv`}
                                            width="996"
                                            height="718"
                                            useOffscreenRenderer={true}
                                            playRequest={true}
                                            disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </section>
                        {this.state.kampanja && <TrajanjePromocije pocetakPromocije={this.getUTCDate(this.state.kampanja.aktivnoOd)} krajPromocije={this.getUTCDate(this.state.kampanja.aktivnoDo)} />}
                    </div>
                    <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" style={{ position: 'static' }}>
                        <div className='margin-top margin-bottom'> &nbsp;</div>
                        <div className='margin-top margin-bottom '> &nbsp;</div>

                        <div className='margin-top  '> &nbsp;</div>


                        <div className="padding-sides-medium-2 hallowen-bonus-promocija" style={{ backgroundColor: '#153659', color: '#fff' }}>
                            <div className='mobile-visible'><div style={{ height: '12px' }}></div></div>
                            <div className=''><div style={{ height: '10px' }}></div></div>
                            <h2 className='v4 margin-bottom-small' style={{ color: '#fffffb' }}>Udvostruči dobitak</h2>
                            <span style={{ color: '#98bbcf' }}>
                                <img src='content/images/bonusi/img_skulls.png' className="skulls"></img>
                                <span>Osvoji najveći pojedinačni dobitak u Halloween utrci igrajući spooky igrice i mi ćemo ga <span style={{ color: '#fffffb' }}><b>udvostručiti</b></span> do maksimalnog iznosa od 50.000 kn (6636,14 €)!
                                </span>
                            </span>
                        </div>

                        <div className="padding-sides-medium-2 border-top-small white-background">
                            <h2 className='v4 margin-bottom-small'>Igraj bez straha jer sreća prati hrabre! 👻</h2>
                            Uključi se u straaašno dobru Halloween casino utrku od {this.state.kampanja && <span>{casino.utils.dateToShortDateString(new Date(this.state.kampanja.aktivnoOd))} u {casino.utils.dateToTimeString(new Date(this.state.kampanja.aktivnoOd))} do {casino.utils.dateToShortDateString(new Date(this.state.kampanja.aktivnoDo))} u {casino.utils.dateToTimeString(new Date(this.state.kampanja.aktivnoDo))}.
                            </span>}
                            <p>
                                Zaigraj jezive igre, a <b>300 igrača</b> koji tijekom utrke odigraju najveći broj jezivih vrtnji od minimalno 1,00 kn (0,13 €) dijele <b>50.000 kn (6.636,14 €)</b>.
                            </p>

                            <div className='margin-bottom-small'>&nbsp;</div>
                            <div className="segment v2">
                                {this.state.tabs && this.state.tabs.map((tab) =>
                                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                                )}
                            </div>
                        </div>

                        {this.state.selectedTab == 'Nagrade' && this.state.kampanja?.nagrade &&
                            <div>
                                <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2  '>Nagrade u vrijednosti od {casino.utils.numberWithCurrencyFromated(50000, 'EUR')}</h2>
                                <div className='padding-sides-medium-2 max-width-70 text-center   '>

                                    <div className='bonus-badge gold max-width-35 as-inline-block '>
                                        <img src='content/images/bonusi/img_award_gold@2x.png' />
                                        <div className='bonus-badge--footer'>
                                            <span>1. mjesto</span>
                                            <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.numberWithCurrencyFromated(this.state.kampanja.nagrade[0].iznos, this.state.kampanja.valuta)}</span>
                                        </div>
                                    </div>
                                    <div className='bonus-badge silver max-width-35 as-inline-block'>
                                        <img src='content/images/bonusi/img_award_silver@2x.png' />
                                        <div className='bonus-badge--footer'>
                                            <span>2. mjesto</span>
                                            <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.numberWithCurrencyFromated(this.state.kampanja.nagrade[1].iznos, this.state.kampanja.valuta)}</span>
                                        </div>
                                    </div>
                                    <div className='bonus-badge bronze max-width-35 as-inline-block'>
                                        <img src='content/images/bonusi/img_award_bronze@2x.png' />
                                        <div className='bonus-badge--footer'>
                                            <span>3. mjesto</span>
                                            <span className="bonus-badge--footer--iznos">{this.state.kampanja && casino.utils.numberWithCurrencyFromated(this.state.kampanja.nagrade[2].iznos, this.state.kampanja.valuta)}</span>
                                        </div>
                                    </div>

                                </div>
                                <table className="margin-top table-1 v2 max-width-70">
                                    <tbody>
                                        {this.state.kampanja && this.state.kampanja.nagrade.map((nagrada, index) =>
                                        (index > 2 && <tr key={index} className={index > 3 ? 'horizontal-lines' : ''}>
                                            <td className='text text-1'>{this.setPlace(nagrada, index)}</td>
                                            <td className='text text-1  text-bold text-right'>{casino.utils.numberWithCurrencyFromated(nagrada.iznos, this.state.kampanja.valuta)}</td>
                                        </tr>)
                                        )}
                                    </tbody>
                                </table>
                            </div>}




                        {this.state.selectedTab == 'Rezultati' &&
                            <div>
                                {/* <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2'>Trenutni poredak</h2> */}
                                <div className="margin-top">
                                    {this.state.kampanja?.nagrade && <BonusPobjednici {...this.props} aktivno={true} najveciBrojSpinovaID={47} podebljajNajveciDobitakID={48} sifra='casinoBonus' aktivniBodoviText='Spinova' hidePrethodni={true} />}
                                </div>
                                {this.state.kampanja?.nagrade && <div className='padding-sides-medium-2 text-left text text-6 margin-top-small '>
                                    * rezultati se osvježavaju svakih 5 minuta
                                    <br />

                                    <br />
                                </div>}
                                <div>&nbsp;</div>
                            </div>}





                        {this.state.selectedTab == 'Spooky igre' && this.state.kampanja?.igreSifre &&
                            <div>
                                <h2 className='v4 margin-bottom-small margin-top padding-sides-medium-2'>Spooky igre</h2>
                                <div className="margin-top">

                                    <div className="clearfix games-container white">
                                        <div>
                                            {
                                                this.state && this.state.igre ?
                                                    this.dohvatiBonusIgre().map(this.renderIgra) :
                                                    <div>Dohvaćanje igara...</div>
                                            }
                                        </div>
                                    </div>

                                </div>

                            </div>}
                        {this.state.selectedTab != 'Rezultati' &&

                            <div className="text-center">
                                <hr />
                                <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/Halloween2022.pdf?c=${casino.config.guiCacheVerzija}`}>
                                    <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                                </a>
                            </div>
                        }


                    </div>
                </div>
                <GameDetails  {...this.props} {...this.state} routePrefix="/promotions/halloween"></GameDetails>
                <ObavijestiCasino {...this.props}></ObavijestiCasino>
            </div>

        );
    }
};
